import { useState, useEffect } from 'react'

export type ScrollDirection = 'up' | 'down' | null

export function useScrollDirection(threshold = 100): ScrollDirection {
  const [scrollDirection, setScrollDirection] = useState<ScrollDirection>(null)

  useEffect(() => {
    let lastScroll = window.scrollY

    const handleScroll = () => {
      const currentScroll = window.scrollY
      const scrollDiff = currentScroll - lastScroll

      if (Math.abs(scrollDiff) > threshold && scrollDiff > 0) {
        lastScroll = currentScroll
        setScrollDirection('down')
      } else if (Math.abs(scrollDiff) > threshold && scrollDiff < 0) {
        lastScroll = currentScroll
        setScrollDirection('up')
      }
    }

    window?.addEventListener('scroll', handleScroll, {
      passive: true
    })

    return () => {
      window?.removeEventListener('scroll', handleScroll)
    }
  }, [threshold])

  return scrollDirection
}

export default useScrollDirection
